import { NgModule } from '@angular/core';
import { NbCardModule } from '@nebular/theme';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { CommonModule } from '@angular/common';
import { ThemeModule } from '../../@theme/theme.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoginService } from './login.service';
import { ModalFalhaLoginComponent } from './modal-falha-login/modal-falha-login.component';


@NgModule({
  imports: [
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeModule,
    CommonModule,
    NbCardModule,    
  ],
  declarations: [
    LoginComponent,
    ModalFalhaLoginComponent,
  ],
  entryComponents:[
    ModalFalhaLoginComponent,
  ],
})
export class LoginModule {
}
